export default __webpack_public_path__ + "static/media/chat-3.1c11099f.JPG";